import React from 'react';

type SupplierSectionHeadingProps = {
  title: string;
  subtitle?: string;
  icon?: string;
};

const SupplierSectionHeading: React.FC<SupplierSectionHeadingProps> = ({ title, subtitle, icon }) => (
  <div className="sp-section-heading">
    <div className="sp-section-heading__row">
      {icon && <i className={`fa ${icon}`} aria-hidden="true" />}
      <h2>{title}</h2>
    </div>
    {subtitle && <p className="sp-section-heading__sub">{subtitle}</p>}
  </div>
);

export default SupplierSectionHeading;
